import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Category from "./Category";
import type Tweet from "./Tweet";

@Model()
class TwitterUser extends ApplicationRecord {
  static jsonapiType = "twitter_users";

  @Attr() avatarImage: string;

  @BelongsTo() category: Category;

  @Attr() categoryId: number;

  @Attr() city: string;

  @Attr() country: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() followerCount: number;

  @Attr() gender: string;

  @Attr() influence: number;

  @Attr() label: string;

  @Attr() latitude: number;

  @Attr() longitude: number;

  @Attr() name: string;

  @Attr() outreach: number;

  @Attr() profileDescription: string;

  @Attr() state: string;

  @HasMany() tweets: Tweet[];

  @Attr({ persist: false }) updatedAt: string;

  @Attr() username: string;

  @Attr() usernameHash: string;

  @Attr() verified: boolean;
}

export default TwitterUser;
